// extracted by mini-css-extract-plugin
export default {"bPart":"Login_bPart__ZpXIE"};